module.exports = __webpack_public_path__ + "static/weather-mobile-light-plp-695da6c40303215a5461fe4c6952e4f9.png";